import { useState } from 'react';
import { useRouter } from 'next/router';
import { TextLink } from '@/components/TextLink';
import { TextInput, Button } from '@zopauk/web-ui';
import type { BlogNavbarFragment } from '@/utils/dato/generated';

const BlogNavbar = ({ blogHomepage, categories }: BlogNavbarFragment) => {
  const { asPath, query } = useRouter();
  const [open, setOpen] = useState(false);

  const items = [
    blogHomepage?.slug && {
      active: asPath.split('?')[0] === `/blog`,
      href: `/blog`,
      label: 'Home',
      id: 'home',
    },
    ...categories.map(({ title, slug, id }) => ({
      active: asPath.includes(`/blog/category/${slug}`),
      href: `/blog/category/${slug}`,
      label: title,
      id,
    })),
  ].filter(Boolean) as { active: boolean; label: string; href: string; id: string }[];

  return (
    <div className="bg-background xl:bg-base-100 xl:flex xl:justify-around py-5 px-5 xl:px-0 xl:py-3">
      <nav
        className={`relative xl:flex xl:items-center overflow-hidden transition-[max-height] duration-300 ease-in-out xl:mb-0 xl:overflow-visible xl:max-h-none 
        ${open ? 'max-h-[300px]' : 'max-h-[50px]'}`}
      >
        <ul className="list-none relative flex flex-col xl:flex-row">
          {items.map(({ active, label, href, id }) => (
            <li className="relative p-3 pt-5 xl:px-5 xl:p-4 font-semibold" key={`item-blog-${id}`}>
              <TextLink className="no-underline hover:text-base-300" href={href}>
                {label}
              </TextLink>
              {active ? (
                <span className="hidden xl:block absolute left-0 bottom-[-12px] w-full h-[2px] bg-primary" />
              ) : null}
            </li>
          ))}
        </ul>
        <Button
          className="absolute right-2 top-2 xl:hidden"
          onClick={() => setOpen(!open)}
          variant="secondary"
          size="xs"
          outline
        >
          <span className="material-symbols-outlined">{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
        </Button>
      </nav>

      <form
        className="hidden xl:flex relative w-full xl:w-auto mt-4 xl:m-0"
        action="/blog/search"
        autoComplete="off"
        method="get"
      >
        <TextInput
          startIcon={<span className="material-symbols-outlined">search</span>}
          defaultValue={query?.search || ''}
          placeholder="Search blog..."
          id="blog-search"
          name="search"
          type="search"
        />
      </form>
    </div>
  );
};

export default BlogNavbar;
